module.exports = "<div *ngIf='isEnabled && messageKey' class='with-errors text-danger'>\r\n  <span>{{ messageKey | translate }}</span>\r\n</div>"